import { Head, Link, useForm } from "@inertiajs/react"
import type { FormEvent } from "react"

import AppLogo from "@/components/app-logo"
import { Button } from "@/components/ui/button"
import { newSessionPath, oauthConfirmationPath } from "@/routes"

interface Props {
  email: string
  name: string
}

export default function New({ email, name }: Props) {
  const { post, processing } = useForm({})

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post(oauthConfirmationPath())
  }

  return (
    <>
      <Head title="Confirm Account" />

      <div className="vignette noise bg-bg-body flex min-h-screen items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <Link href="/" className="inline-flex items-center justify-center">
              <AppLogo />
            </Link>
          </div>

          <div className="border-border bg-bg-card rounded-lg border p-8 shadow-lg">
            <h1 className="font-display mb-2 text-center text-2xl tracking-wide">
              Join the Doomed
            </h1>

            <p className="text-bone-muted mb-6 text-center text-sm">
              This is you, right?
            </p>

            <div className="bg-bg-body mb-6 space-y-3 rounded-md p-4">
              <div className="flex items-center justify-between">
                <span className="text-bone-muted text-sm">Name</span>
                <span className="text-bone text-sm font-medium">{name}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-bone-muted text-sm">Email</span>
                <span className="text-bone text-sm font-medium">{email}</span>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <Button type="submit" className="w-full" disabled={processing}>
                I Accept My Fate
              </Button>

              <Link
                href={newSessionPath()}
                className="text-bone-muted hover:text-bone block text-center text-sm"
              >
                ← Wrong person? Flee.
              </Link>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
